import React from 'react';
import {
  OtpContainer,
  OtpContent,
  OtpTitle,
  OtpDescription,
  OtpFieldsContent,
  OtpFieldTitle,
  OtpInputContent,
  OtpInputField,
  OtpTimerContent,
  OtpTimerButton,
  OtpTimerSeconds,
  OtpTimerProgressBarContent,
  OtpTimerProgressBar,
  OtpFooter,
  OtpFooterButton,
  OtpInputErrorDescription,
  OtpAttempts
} from './styles';

const Otp = ({ open, setShowOtpModal, handleChangeOtp, fields, timer, timeWidth, errorOtp, disableOtpFields, resendCode, attempts, totalAttempts }) => {
  return (
    <OtpContainer open={open} id="otp">
      <OtpContent>
        <OtpTitle>Confirmación código</OtpTitle>
        <OtpDescription>
          Ingresa el código OTP enviado al cliente, al cual tiene  una vigencia de 5min.
          Para continuar con el de prospección.
        </OtpDescription>
        <OtpFieldsContent>
          <OtpFieldTitle>Ingresa Código Otp de 6 Dígitos</OtpFieldTitle>
          <OtpInputContent>
            {fields.map(((name, key) => (
              <OtpInputField key={key} onChange={handleChangeOtp} name={name} maxLength={1} error={errorOtp} disabled={disableOtpFields} id={`input${key}`} />
            )))}
          </OtpInputContent>
        </OtpFieldsContent>
        <OtpAttempts lastAttempt={attempts === totalAttempts}>Intentos: {`${attempts} / ${totalAttempts}`}</OtpAttempts>
        {errorOtp && (
          <OtpInputErrorDescription>El código es errado, intentalo de nuevo o reenvia otro</OtpInputErrorDescription>
        )}
        <OtpTimerContent>
          <OtpTimerButton onClick={resendCode} id="resent-code">Reenviar</OtpTimerButton>
        </OtpTimerContent>
        <OtpTimerProgressBarContent>
          <OtpTimerProgressBar timeWidth={timeWidth}  />
        </OtpTimerProgressBarContent>
        <OtpFooter>
          <OtpFooterButton onClick={() => setShowOtpModal(false)} id="cancel">Cancelar</OtpFooterButton>
        </OtpFooter>
      </OtpContent>
    </OtpContainer>
  )
}

export default Otp;
